import { Module } from 'vuex';

import { RootState } from 'frontend/types';

interface SubscriptionState {
  subscription_id: number;
}

const subscription: Module<SubscriptionState, RootState> = {
  namespaced: true,
  state: {} as SubscriptionState,
  mutations: {
    setValue(state: SubscriptionState, value: SubscriptionState): void {
      state.subscription_id = value.subscription_id;
    },
  },
};

export default subscription;
